import React, {Component} from 'react';
import {Col, Row, Collapse, Button} from 'antd'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Params from './Params';
import ShowSQL from './ShowSQL';
import * as reportServices from '../../../redux/services/reportService';
import ReportResults from './ReportResults'
import moment from 'moment';

class Report extends Component {
  constructor(props) {
    super(props);
    this.getReportResults = this.props.services.getReportResults.bind(this);
    this.state = {
      orginizationId: -1,
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.orgId) {
      return { orginizationId : props.orgId }
    }
  }

  componentDidMount() {

    this.props.services.getReportMetaData(this.props.reportId, this.getRunOnce(this.props.reportParams));

  }

  getRunOnce(reportParams){
    var returnVal = false;
    if(reportParams){
      Object.keys(reportParams).forEach((param)=>{
          if(param==='runOnce'){
              returnVal= true;
        }
      })
    }

    return returnVal;

  }


  componentDidUpdate(prevProps, prevState, snapshot){

    if(((this.props.reportData.reportMetaData && this.props.reportData.reportMetaData.runImmediately)
       && !(prevProps.reportData.reportMetaData && prevProps.reportData.reportMetaData.runImmediately)) ||
       ((this.props.reportData.reportMetaData && this.props.reportData.reportMetaData.runOnce)
          && !(prevProps.reportData.reportMetaData && prevProps.reportData.reportMetaData.runOnce))
       ){
         var values = {}

         this.props.reportData.reportMetaData.params.forEach(param =>
         {
           values[param.name] = param.defaultValue;
         })

        if(this.props.reportParams && Object.keys(this.props.reportParams).length>1){
           Object.keys(this.props.reportParams).forEach((param)=>{
             if(param!='reportId'){
               if(this.props.reportParams[param]){
                 values[param] = this.props.reportParams[param];
               }
             }
           })
         }

         values["TIMEZONEOFF"] = moment().local().format('ZZ');
         if (this.state.orginizationId !== -1) {
          values["ORG_ID"] = this.props.orgId;
         }

         this.getReportResults(this.props.reportData.reportMetaData.id, values);
      }

  }





  render() {
    const {orginizationId} = this.state;
    const reportData =  {
      ...this.props.reportData,
      services: this.props.services,
      reportParams: this.props.reportParams,
      orgId : orginizationId
    }

    return (<div>

        <Params {...reportData}/>
        <ReportResults {...reportData}/>
        {orginizationId === -1 ?<ShowSQL {...reportData}/>: null}

    </div>)
  }
}

const mapStateToProps = (state) => ({reportData: state.reportReducer})

const mapDispatchToProps = (dispatch) => ({
  services: bindActionCreators(Object.assign({}, reportServices), dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Report)
